import Adicionar from './Adicionar';
import Editar from './Editar';

export const VinculosEmpregaticiosAdicionar = Adicionar;
export const VinculosEmpregaticiosEditar = Editar;
